import { render, staticRenderFns } from "./ActionInsertLink.vue?vue&type=template&id=2777d267&scoped=true"
import script from "./ActionInsertLink.vue?vue&type=script&lang=js"
export * from "./ActionInsertLink.vue?vue&type=script&lang=js"
import style0 from "./ActionInsertLink.vue?vue&type=style&index=0&id=2777d267&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2777d267",
  null
  
)

export default component.exports